import React, {FC} from "react"
import styled, {css, withTheme, WithDefaultTheme} from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

interface Props extends WithDefaultTheme {
  selected?: boolean,
  title: string,
  img: string,
  onClick: () => void,
}

type CSSProps = Omit<Props, "title" | "img" | "onClick">

const Container = styled.div<CSSProps>`
  flex: 1;
  cursor: pointer;
  ${({selected, theme}) => css`
    border: 2px solid ${selected ? theme.colors.primary2 : theme.colors.greys.light};
    background-color: ${theme.colors.greys.lightest};
    padding: ${theme.spacing.two};

    &:hover {
      border: 2px solid ${selected ? theme.colors.primary2 : theme.colors.primary1};
    }
  `}
`

const RadioContainer = styled.div<CSSProps>`
  ${({selected, theme}) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: 1px solid ${selected ? theme.colors.primary2 : theme.colors.utility.subdued};
    border-radius: 50%;
    ${Container}:hover & {
      border-color: ${selected ? theme.colors.primary2 : theme.colors.primary1};
    }
  `}
`

const RadioItem = styled.div<CSSProps>`
  ${({selected, theme}) => css`
    width: 12px;
    height: 12px;
    background-color: ${selected ? theme.colors.primary2 : theme.colors.utility.subdued};
    border-radius: 50%;
  `}
`

const AllocationJourneyCardOption: FC<Props> = ({selected, title, img, onClick, theme}) => (
  <Container selected={selected} onClick={onClick}>
    <Flex direction="column" alignItems="center">
      <Flex alignSelf="flex-end">
        <RadioContainer selected={selected}>
          {selected && <RadioItem selected={selected} />}
        </RadioContainer>
      </Flex>
      <img src={img} alt={img} />
      <Body large color={theme.colors.primary2} weight={selected ? "semibold" : "default"} textAlign="center">
        <FormattedMessage id={title} />
      </Body>
    </Flex>
  </Container>
)

export default withTheme(AllocationJourneyCardOption)
